import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import { authFetch } from '../../libs/cookie/Cookie'

import Contractor, { ContractorType } from '../../components/people/contractor/Contractor'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import { isValidPrivacy, getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import MultipleCheckbox from '../../libs/ui/inputs/MultipleCheckbox'
import SiNo, { SiNoType, getSiNoValue, getBoolean } from '../../components/siNo/SiNo'

import { isEmpty } from '../../libs/validation/stringRegex'
import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { getTipoSport } from '../../libs/initialization/remoteInits'

import { injuryUpdate, injuryPageInitialState, InjuryPageState, InjuryPageProps } from './InjuryPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class InjuryPage extends BasePage<InjuryPageProps, InjuryPageState> {
    constructor (props: any) {
        super(props)

        this.state = {
            ...injuryPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateContractor = this.updateContractor.bind(this)

        this.updateProblemi_precedenti = this.updateProblemi_precedenti.bind(this)
        this.updateSport = this.updateSport.bind(this)
        this.updatePratichiSport = this.updatePratichiSport.bind(this)
        this.updateTipoSport = this.updateTipoSport.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipo_sport === undefined) {
            getTipoSport (this.updateTipoSport, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="injury_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <SiNo 
                                                label='Hai minorazioni funzionali, malattie, difetti fisici e precedenti infortuni?'
                                                id='problemi_precedenti'
                                                value={ getSiNoValue(this.state.problemi_precedenti) }
                                                callback={this.updateProblemi_precedenti}
                                                error={this.state.problemi_precedentiError}
                                            />

                                            <SiNo 
                                                label='Pratichi sport?'
                                                id='pratichiSport'
                                                value={ getSiNoValue(this.state.partichiSport) }
                                                callback={this.updatePratichiSport}
                                                error={this.state.partichiSportError}
                                            />

                                            { this.state.partichiSport &&
                                                <MultipleCheckbox
                                                    id='sport'
                                                    label='Quali sport pratichi?'
                                                    value={this.state.sport}
                                                    options={this.state.tipo_sport}
                                                    error={this.state.sportError}
                                                    callBack={this.updateSport}
                                                    isMultiple={true}
                                                />
                                            }
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}

                                            linkAlternativePrivacy={ true }
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>
                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return injuryPageInitialState
    }

    // sovrascritto --> non usar per copia incolla ???
    updateContractor (c: ContractorType) {
        const next = {
            problemi_precedenti: this.state.problemi_precedenti,
            sport: this.state.sport,
            partichiSport: this.state.partichiSport,

            contractor: c,
            contractorError: undefined
        }

        if (c.tipoPersona === 'fisica') {
            next.contractor.nomeAzienda = undefined
            next.contractor.pIva = undefined
            next.contractor.ragioneSociale = undefined
        } else {
            next.contractor.professione = undefined

            next.problemi_precedenti = undefined
            next.sport = undefined
            next.partichiSport = undefined
        }

        this.saveStateAndRedux( next )
    }
    
    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } else {
            let problemi_precedentiErro = undefined
            let sportErro = undefined
            let pratichiErro = undefined
            let noMotorPrivacyErro = undefined

            let global = undefined

            if (errorString === 'PROBLEMI_PRECEDENTI') {
                problemi_precedentiErro = 'Valore non valido / mancante'
                global = 'Indicare eventuali problemi precedenti'
            }
            else if (errorString === 'PRATICHI') {
                pratichiErro = 'Valore non valido / mancante'
                global = 'Indicare se si pratica sport'
            }
            else if (errorString === 'SPORT') {
                sportErro = 'Valore non valido / mancante'
                global = 'Selezionare gli sport praticati'
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                problemi_precedentiError: problemi_precedentiErro,
                sportError: sportErro,
                partichiSportError: pratichiErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            data_nascita: this.state.contractor?.data_nascita !== undefined ? this.state.contractor.data_nascita : null,
            problemi_precedenti: this.state.problemi_precedenti ?? null,
            sport: this.state.sport ?? null,
        }
    }
    
    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    injuryUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore
    private updatePratichiSport (val: SiNoType) {
        const pratica = getBoolean(val)

        this.setState({
            partichiSport: pratica
        }, () => {
            this.saveStateAndRedux ({
                sport: (pratica) ? undefined : 'nessuno|',
                sportError: undefined
            })
        })
    }

    private updateProblemi_precedenti (val: SiNoType) {
        this.saveStateAndRedux({
            problemi_precedenti: getBoolean(val),
            problemi_precedentiError: undefined
        })
    }
    private updateSport (val: string | undefined, add: boolean) {
        let next = this.state.sport

        if ( val ) {
            if (add) {
                if (!next?.includes(val + '|')) {
                    next = (next ?? '') + val + '|'
                }
            }
            else {
                next = (next ?? '').replace( val + '|', '')
            }
        }

        this.saveStateAndRedux({
            sport: next,
            sportError: undefined
        })
    }

    private updateTipoSport (val: any) {
        let next = val

        if (next.nessuno) {
            delete next.nessuno
        }

        this.setState({
            tipo_sport: next
        })
    }

    private async step2Validation () {
        let error = undefined

         if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }

        // solo preve
        else if (
            this.state.contractor.tipoPersona === 'fisica' &&
            this.state.problemi_precedenti === undefined
        ) {
            error = "PROBLEMI_PRECEDENTI"
        }
        else if (
            this.state.contractor.tipoPersona === 'fisica' &&
            this.state.partichiSport === undefined
        ) {
            error = 'PRATICHI'
        }
        else if (
            this.state.contractor.tipoPersona === 'fisica' &&
            isEmpty(this.state.sport)
        ) {
            error = "SPORT"
        }

        // comuni
        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    problemi_precedenti: state.problemi_precedenti,
    sport: state.sport,
    partichiSport: state.partichiSport,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user,

    actualPage: state.actualPage,
  }
}

export default connect(mapState) (InjuryPage)